import React, { useState, useEffect } from "react";
import { Row, Col, Button, Input, Drawer, message } from "antd";
import Close from "../../../../assets/images/close-x.svg";
import CancelArrow from "../../../../assets/images/cancelArrow.svg";
import db from "../../../../database";

const LoyaltyOTPDrawer = ({
  loyalityOtpModalVisible,
  setLoyalityOtpModalVisible,
  setSelectedPaymentMethod,
  setLoyaltyInputValue,
  loyaltyInputValue,
  cart,
  loyaltyInputRef,
  showOtpPopup,
  posConfig,
  verifyLoyalty,
  checkLoyality,
  handleLoyalityInput,
  width,
  t,
}) => {
  const [loyaltySubmitting, setLoyaltySubmitting] = useState(false);
  const [loyaltyLevelName, setLoyaltyLevelName] = useState("");

  const cwrLoyaltyLevelId = cart?.customer?.loyaltyLevel?.cwrLoyaltyLevelId;
  const loyaltyLevelNameFromCart = cart?.customer?.loyaltyLevel?.name;

  useEffect(() => {
    if (!loyalityOtpModalVisible) return;

    if (loyaltyLevelNameFromCart) {
      setLoyaltyLevelName(loyaltyLevelNameFromCart);
      return;
    }

    if (!cwrLoyaltyLevelId) {
      setLoyaltyLevelName("");
      return;
    }

    let cancelled = false;
    (async () => {
      const loyaltyLevel = await db.loyalityData.get(cwrLoyaltyLevelId);
      if (!cancelled) {
        setLoyaltyLevelName(loyaltyLevel?.name || "");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [loyalityOtpModalVisible, cwrLoyaltyLevelId, loyaltyLevelNameFromCart]);

  const handleLoyaltyRedeem = async () => {
    if (loyaltySubmitting) return;
    if (cart?.customer?.retlLoyaltyBalance >= loyaltyInputValue) {
      setLoyaltySubmitting(true);
      try {
        if (posConfig?.enableLoyalty === "Y") {
          await verifyLoyalty();
        } else {
          await checkLoyality();
        }
      } finally {
        setLoyaltySubmitting(false);
      }
    } else {
      message.error(`${t("loyalty_redeemption_error")}`);
    }
  };

  return (
    <Drawer
      placement="bottom"
      closable={false}
      // title={
      //   <div style={{ display: "flex", alignItems: "center" }}>
      //     <p style={{ fontSize: "1.6vw", paddingTop: "3vh", fontWeight: "500", color: "#2F3856", flex: 1, textAlign: "center" }}>Loyalty Points</p>
      //     <img src={Close} onClick={()=>setLoyalityOtpModalVisible(false)} style={{ marginLeft: "auto", paddingBottom: "5vh", cursor: "pointer" }} />
      //   </div>
      // }
      open={loyalityOtpModalVisible}
      className="filter"
      styles={{ body: { paddingBottom: 0 } }}
      onClose={() => {
        setSelectedPaymentMethod({});
        setLoyalityOtpModalVisible(false);
        setLoyaltyInputValue("");
      }}
      //  id="sm-drawer-close"
      height="80vh"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingBottom: "2vh",
        }}
      >
        <p
          style={{
            fontSize: "1.3vw",
            paddingTop: "1vh",
            fontWeight: "500",
            color: "#2F3856",
            flex: 1,
            textAlign: "center",
            margin: 0,
          }}
        >
          Redeem Loyalty
        </p>
        <img
          src={Close}
          onClick={() => {
            setLoyalityOtpModalVisible(false);
            setSelectedPaymentMethod({});
          }}
          style={{ marginLeft: "auto", cursor: "pointer" }}
        />
      </div>
      <Row>
        <Col span={2} />
        <Col span={9} style={{ paddingRight: "1vw" }}>
          <Row style={{ marginTop: "" }}>
            <Col span={24}>
              <p
                style={{
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "1vw",
                }}
              >
                Loyalty Membership
              </p>
              <p
                style={{
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "2.5vw",
                }}
              >
                {loyaltyLevelName}
              </p>
            </Col>

            <Col span={24} style={{ paddingTop: "10vh" }}>
              <p
                style={{
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "1vw",
                }}
              >
                Loyalty Member Since
              </p>
              <p
                style={{
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "2.5vw",
                }}
              >
                10/08/2023
              </p>
            </Col>

            <Col span={24} style={{ paddingTop: "10vh" }}>
              <p
                style={{
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "1vw",
                }}
              >
                Loyalty Points Available
              </p>
              <p
                style={{
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "2.5vw",
                }}
              >
                {(cart?.customer?.retlLoyaltyBalance ?? 0).toFixed(2)}
              </p>
            </Col>
          </Row>
        </Col>
        <Col span={2} />
        <Col span={11} style={{ marginBottom: "0vh" }}>
          <Row style={{ padding: "0 1% 3vh 3.5%" }} gutter={[8, 8]}>
            <Col span={20}>
              <p
                style={{
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "1vw",
                }}
              >
                Enter Points to redeem
              </p>
              <Input
                ref={loyaltyInputRef}
                disabled={showOtpPopup}
                // ref={manualDiscountInputRef}
                // disabled={enableManualDiscountInput}
                // value={manualDiscountInput}
                onPressEnter={handleLoyaltyRedeem}
                onBlur={() => {
                  if (loyalityOtpModalVisible) {
                    setTimeout(() => {
                      loyaltyInputRef.current?.focus();
                    }, 10);
                  }
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d*$/.test(value)) {
                    setLoyaltyInputValue(value);
                  }
                }}
                value={loyaltyInputValue}
                style={{
                  width: "100%",
                  borderRadius: "2px",
                  height: "9.5vh",
                }}
                size="large"
                className="discount-value-input"
                placeholder="Enter value"
              />
            </Col>
          </Row>
          <Row gutter={[8, 8]} style={{ padding: "0 1% 0 3.5%" }}>
            <Col span={5}>
              <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput("1")}>
                1
              </button>
            </Col>
            <Col span={5}>
              <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput("2")}>
                2
              </button>
            </Col>
            <Col span={5}>
              <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput("3")}>
                3
              </button>
            </Col>
            <Col span={5}>
              <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput("x")}>
                <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
              </button>
            </Col>
            <Col span={4} />
            <Col span={5}>
              <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput("4")}>
                4
              </button>
            </Col>
            <Col span={5}>
              <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput("5")}>
                5
              </button>
            </Col>
            <Col span={5}>
              <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput("6")}>
                6
              </button>
            </Col>
            <Col span={5}>
              <button className="amt-dial-btn-super-market-cancel-discount" onClick={() => handleLoyalityInput("clear")}>
                Clear
              </button>
            </Col>
            <Col span={4} />
            <Col span={15}>
              <Row gutter={[8, 6]}>
                <Col span={8}>
                  <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput("7")}>
                    7
                  </button>
                </Col>
                <Col span={8}>
                  <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput("8")}>
                    8
                  </button>
                </Col>
                <Col span={8}>
                  <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput("9")}>
                    9
                  </button>
                </Col>
                <Col span={8}>
                  <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput("0")}>
                    0
                  </button>
                </Col>
                <Col span={8}>
                  <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput("00")}>
                    00
                  </button>
                </Col>
                <Col span={8}>
                  <button className="amt-dial-btn-super-market" onClick={() => handleLoyalityInput(".")}>
                    .
                  </button>
                </Col>
              </Row>
            </Col>
            <Col span={5}>
              <button
                // id="sm-amount-buttonEnter"
                className="amt-dial-btn-market-discount"
                disabled={loyaltySubmitting}
                onClick={handleLoyaltyRedeem}
              >
                Enter
              </button>
            </Col>
            <Col span={4} />
          </Row>
          <Row style={{ marginTop: "2vh", padding: "0 1% 0 3.5%" }} gutter={[8, 8]}>
            <Col span={20}>
              <Button
                className="discount-apply-btn"
                disabled={loyaltySubmitting}
                loading={loyaltySubmitting}
                onClick={handleLoyaltyRedeem}
              >
                Redeem
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Drawer>
  );
};

export default LoyaltyOTPDrawer;
